if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindNavButtons();
      }

      bindNavButtons() {
        if (this.kzNavBound) return;
        this.kzNavBound = true;
        const prevBtn = this.querySelector('.kz-modal-prev');
        const nextBtn = this.querySelector('.kz-modal-next');
        const content = this.querySelector('.product-media-modal__content');

        [prevBtn, nextBtn, content].forEach((element) => {
          if (element) element.addEventListener('pointerup', (event) => event.stopPropagation());
        });

        if (prevBtn) prevBtn.addEventListener('click', () => this.showMediaAtIndex(this.currentIndex - 1));
        if (nextBtn) nextBtn.addEventListener('click', () => this.showMediaAtIndex(this.currentIndex + 1));
      }

      showActiveMedia() {
        this.mediaElements = Array.from(this.querySelectorAll('[data-media-id]'));
        const targetId = this.openedBy.getAttribute('data-media-id');
        const startIndex = this.mediaElements.findIndex(
          (element) => element.getAttribute('data-media-id') === targetId
        );
        this.showMediaAtIndex(startIndex > -1 ? startIndex : 0);
      }

      showMediaAtIndex(index) {
        if (!this.mediaElements || !this.mediaElements.length) return;
        const total = this.mediaElements.length;
        const newIndex = ((index % total) + total) % total;

        this.mediaElements.forEach((element) => element.classList.remove('active'));
        const activeMedia = this.mediaElements[newIndex];
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        this.currentIndex = newIndex;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        const image = activeMedia.matches('img') ? activeMedia : activeMedia.querySelector('img');
        this.attachZoom(image);
      }

      attachZoom(image) {
        if (!image || image.dataset.kzZoomBound) return;
        image.dataset.kzZoomBound = 'true';
        image.style.cursor = 'zoom-in';

        image.addEventListener('click', (event) => {
          if (this.kzZoomOverlay) return;

          const rect = image.getBoundingClientRect();
          const overlay = document.createElement('div');
          overlay.className = 'kz-modal-zoom-overlay';
          overlay.appendChild(document.createElement('span'));
          overlay.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
          overlay.style.top = `${rect.top}px`;
          overlay.style.left = `${rect.left}px`;
          overlay.style.width = `${rect.width}px`;
          overlay.style.height = `${rect.height}px`;
          document.body.appendChild(overlay);
          this.kzZoomOverlay = overlay;

          const move = (moveEvent) => {
            const xPercent = ((moveEvent.clientX - rect.left) / rect.width) * 100;
            const yPercent = ((moveEvent.clientY - rect.top) / rect.height) * 100;
            overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
          };

          const close = () => {
            overlay.remove();
            this.kzZoomOverlay = null;
          };

          overlay.addEventListener('mousemove', move);
          overlay.addEventListener('click', close);
          overlay.addEventListener('mouseleave', close);
          move(event);
        });
      }
    }
  );
}
